/* eslint-disable no-unused-vars */
/** @jsx jsx */
import { jsx } from '@emotion/core'
import React, { useState, useContext, useEffect } from 'react'
import {
  CriteriaRow,
  Title,
  FullHeightSizer,
  Content,
  Label,
  // Filler,
} from 'core/screen-util'
import MarginAnalysisContext from './MarginAnalysisContext'
import {
  getUnitNameMap,
  getApiTargetInfo,
  getUtilityNameMap,
  getUnits,
  getClientInfo,
  getUserInfo,
  getPnodeZoneEffective,
  isValidYearRange,
  getValidYearRange,
} from 'core'
import {
  SpinContext,
  ErrorContext,
  // UnitSelectionContext,
  PNodeZoneContext,
} from 'context'
import { DatePicker, Checkbox, Button, message, Select } from 'antd'
import {
  getMarginAnalysisEventPlanningRetrieveData,
  getMarginAnalysisRetrieveData,
  // marginAnalysisExportData,
  // exportData,
  marginAnalysisExportBlob,
} from 'api/pgads'
import { connect } from 'react-redux'
// eslint-disable-next-line no-unused-vars
import moment from 'moment'
import EventData from './component/EventData'
import EventTotals from './component/EventTotals'
import MonthlyGraphData from './component/MonthlyDataGraph'
import EventSummaryByCauseCode from './component/EventSummaryByCauseCode'
import HourlyDetailsModal from './component/HourlyDetailsModal'
import CommercialRechart from './component/CommercialPieRechart'
import LostMarginRechartPie from './component/LostMarginRechartPie'
import CauseCodeGroupReChartPie from './component/CauseGroupRechartPie'
// import ExportComponents from 'core/component/ExportComponent'
import { getExportDataHeaders } from './margin-client'
import MarginUtilityUnitSelection from './MarginAnalysisUtilityUnitSelection'
import { toXlsxColumns, toXlsxData, writeToExcel } from './Headers'
import { saveAs } from 'file-saver'
import { KINDLE_CLIENT } from 'client'
import EventPlannerDialog from './component/EventPlannerDialogWF'
import { isErrorContains } from 'core/component/JcTmpErrorDialog'
import { getFinalData } from './utils'
import { compressJsonData } from './../compress-utils'
const MarginAnalysis = ({
  targetInfo,
  // utilityNameMap,
  // unitNameMap,
  units,
  CLIENT,
  history,
  userInfo,
  pnodeZoneList,
  // eslint-disable-next-line no-unused-vars
  isEventPlanner = false,
  ...props
}) => {
  const title = isEventPlanner ? 'Event Planning' : 'Margin Analysis'
  const { setSpinning } = useContext(SpinContext)
  const { setError } = useContext(ErrorContext)
  // const { userInfo } = useContext(ClientContext)
  const { unitIdEmktIdMap, getMarginUnitCode } = useContext(PNodeZoneContext)

  const {
    setScenarioList,
    setRetrievedData,
    setWFRetrievedData,
    reloadScenario,
    setSelectedScenario,
    selectedDateRangePicker,
    setSelectedDateRagePicker,
    unitSelection,
    setUnitSelection,
    handlerRetrieveData,
    lostType,
    setLostType,
    ...marginContext
  } = useContext(MarginAnalysisContext)
  const retrievedData = getFinalData(marginContext, false, isEventPlanner)

  const [isRetrieved, setIsRetrieved] = useState(false)
  const clearData = _ => {
    setRetrievedData({})
    setWFRetrievedData({})
    setIsRetrieved(false)
    // setSelectedScenario({})
  }

  const [byCauseCode, setByCauseCode] = useState(false)
  const [showHourlyDetails, setShowHourlyDetails] = useState(false)
  const [eventPlanner, setEventPlanner] = useState(false)
  const retrieveData = _ => {
    if (unitSelection.length === 0) {
      message.warning('Please, Select Unit')
      return
    }
    if (selectedDateRangePicker.length <= 0) {
      message.warning('Please, Select Date Range')
      return
    }

    const isValid = isValidYearRange(
      props.validYearRange,
      selectedDateRangePicker[0],
      selectedDateRangePicker[1]
    )
    if (!isValid) return

    const utility = unitSelection[0]
    const unit = getMarginUnitCode(unitSelection[1])
    const emktId = unitIdEmktIdMap[unitSelection[1]] || 'tempEmktId'
    // scenario: {},

    const reqData = {
      mode: isEventPlanner ? 'PLANNING' : 'NORMAL',
      startDate: selectedDateRangePicker[0].format('YYYY-MM-DD'),
      endDate: selectedDateRangePicker[1].format('YYYY-MM-DD'),
      utility,
      unit,
      emktId,
      // scenario: {},
      showCauseCode: byCauseCode,
      lostType,
      scenario: {
        scenarioName: 'Event Planner',
        author: userInfo.userName,
        utility,
        unit,
        unitId: emktId,
        unitid: emktId,
        emktId,
        startdate: selectedDateRangePicker[0].format('YYYY-MM-DD'),
        enddate: selectedDateRangePicker[1].format('YYYY-MM-DD'),
      },
    }

    setSpinning(true)
    const retrieveDataFunc = isEventPlanner
      ? getMarginAnalysisEventPlanningRetrieveData
      : getMarginAnalysisRetrieveData

    retrieveDataFunc(targetInfo)(reqData).fork(
      error => {
        setError(error)
        setIsRetrieved(false)
        handlerRetrieveData({}, _ => _, isEventPlanner)
      },
      data => {
        setSpinning(false)
        setIsRetrieved(true)

        handlerRetrieveData(data, _ => _, isEventPlanner)
      }
    )
  }

  useEffect(
    _ => {
      // setSelectedDateRagePicker([moment('20180101'), moment('20180103')])
      reloadScenario(targetInfo)
    },
    [setError, targetInfo, setScenarioList, reloadScenario]
  )

  const exportMarginData = _ => {
    const selUnit = units.find(u => u.unitId === unitSelection[1])

    // marginAnalysisExportData(targetInfo)(retrievedData).fork(setError, res => {
    //   setSpinning(false)
    //   exportData(res, 'application/pdf', 'ma')
    // })

    const sd = `${selectedDateRangePicker[0].format('YYYY-MMM-DD')}`
    const ed = `${selectedDateRangePicker[1].format('YYYY-MMM-DD')}`
    const fileNAme =
      'ma-' +
      (selUnit || { unitName: '' }).unitName +
      '-' +
      sd +
      '_' +
      ed +
      '.pdf'

    setSpinning(true)
    marginAnalysisExportBlob(targetInfo)(
      retrievedData,
      {
        byCausecode: byCauseCode,
      },
      fileNAme
    )(_ => setSpinning(false))
  }

  const exportData = async _ => {
    const { hourlyExportData = [] } = retrievedData
    const exportHeader = getExportDataHeaders(CLIENT)

    const columns = toXlsxColumns(exportHeader)
    setSpinning(true)

    const ed = toXlsxData(hourlyExportData, exportHeader)

    const worksheet = [
      {
        // name: 'sheet1',
        columns,
        data: ed,
        metaInfo: [],
        colorInfo: [],
      },
    ]

    const fileBlob = await writeToExcel(worksheet)
    setSpinning(false)
    saveAs(fileBlob, 'ma-events')
  }

  const showHourlyDialog = _ => {
    setShowHourlyDetails(true)
  }

  const whatif = _ => {
    // const selUnit = units.find(u => u.unitId === unitSelection[1])
    if (!unitIdEmktIdMap[unitSelection[1]]) {
      message.warning('ID not found')
      return
    }
    const newScnerio = {
      isNew: true,
      scenarioName: '*New Scenario',
      startdate: selectedDateRangePicker[0].format('YYYY-MM-DD'),
      enddate: selectedDateRangePicker[1].format('YYYY-MM-DD'),
      author: userInfo.userName,
      utility: unitSelection[0],
      unit: getMarginUnitCode(unitSelection[1]),
      unitId: unitIdEmktIdMap[unitSelection[1]],
      unitid: unitIdEmktIdMap[unitSelection[1]],
    }

    // setSelectedScenario(newScnerio)
    // setWFRetrievedData({
    //   ...retrievedData,
    //   request: {
    //     ...retrievedData.request,
    //     mode: 'WHATIF',
    //     scenario: newScnerio,
    //   },
    // })

    const finalData = {
      ...retrievedData,
      request: {
        ...retrievedData.request,
        mode: 'WHATIF',
        scenario: newScnerio,
      },
    }

    const comressdata = compressJsonData(finalData)

    window.localStorage.setItem(
      userInfo.userName + '_whatifCookie',
      JSON.stringify(comressdata)
    )

    const a = window.document.createElement('a')
    a.setAttribute('href', window.location.origin + '/marginanalysiswhatif')
    a.setAttribute('target', '_blank')
    document.body.appendChild(a)
    a.click()
    document.body.removeChild(a)

    // history.push({ pathname: '/marginanalysiswhatif' })
  }

  const pichartWidth = 550
  const actualHeight = 230

  const getUnitNameId = id => {
    const rolId = pnodeZoneList.find(
      u => '' + u.utility + u.rollupEmktid === id
    )
    if (rolId) {
      return '' + rolId.utility + rolId.unit
    }
    return id
  }

  return (
    <div>
      <CriteriaRow
        style={{
          overflowY: 'hidden',
          overflowX: 'auto',
          display: 'flex',
          flexWrap: 'wrap',
        }}
      >
        <div
          style={{ display: 'grid', gridTemplateColumns: '160px 650px auto' }}
        >
          <Title
            style={{
              marginRight: '5px',
              marginBottom: '5px',
            }}
          >
            {title}
          </Title>
          <div>
            <div
              style={{ display: 'grid', gridTemplateColumns: '400px 300px' }}
            >
              <MarginUtilityUnitSelection
                defaultValue={unitSelection}
                utility={unitSelection[0]}
                unit={unitSelection[1]}
                onUnitChange={value => {
                  setUnitSelection(value)
                  // setRetrievedData({})
                  clearData()
                }}
                style={{ width: '400px' }}
              />

              <DatePicker.RangePicker
                style={{ marginLeft: '15px', width: '230px' }}
                allowClear={false}
                format="MMM/DD/YYYY"
                value={selectedDateRangePicker}
                onChange={d => {
                  setSelectedDateRagePicker([
                    d[0].clone().set('hour', 0),
                    d[1]
                      .clone()
                      .set('hour', 0)
                      .add(1, 'd')
                      .subtract(1, 'hours'),
                  ])
                  clearData()
                }}
              />

              {CLIENT === KINDLE_CLIENT && (
                <div
                  style={{
                    display: 'grid',
                    gridTemplateColumns: '20% 80%',
                    marginLeft: '5px',
                    marginRight: '5px',
                    marginTop: '5px',
                    justifyContent: 'left',
                    gridColumnEnd: 'span 2',
                  }}
                >
                  <Label css={{ justifyContent: 'left' }}>
                    Lost Margin Types :
                  </Label>
                  <Select
                    value={lostType}
                    onChange={lost => setLostType(lost)}
                    style={{
                      marginRight: '5px',
                      marginLeft: '5px',
                      width: '90%',
                    }}
                  >
                    <Select.Option value={1}>All Lost Margins</Select.Option>
                    <Select.Option value={2}>
                      Only Forced and Maintenance Lost Margins
                    </Select.Option>
                    <Select.Option value={3}>
                      Only Forced, Maintenance and Planned Lost Margins
                    </Select.Option>
                    <Select.Option value={4}>
                      Only Market Lost Margins
                    </Select.Option>
                  </Select>
                </div>
              )}
            </div>
          </div>
          <div
            style={{
              display: 'flex',
              // flexFlow: 'column',
              gap: '5px',
              flexWrap: 'wrap',
              alignItems: 'center',
            }}
          >
            {!isEventPlanner && (
              <Checkbox
                checked={byCauseCode}
                onChange={e => setByCauseCode(e.target.checked)}
                style={{ marginLeft: '5px' }}
              >
                by Cause Code
              </Checkbox>
            )}
            <Button
              onClick={retrieveData}
              type="primary"
              style={{ marginLeft: '5px' }}
            >
              Retrieve
            </Button>

            <Button
              onClick={showHourlyDialog}
              type="primary"
              style={{ marginLeft: '5px' }}
              disabled={!retrievedData.dls}
            >
              Hourly Detail
            </Button>

            {!isEventPlanner && (
              <Button
                onClick={whatif}
                type="danger"
                style={{ marginLeft: '5px' }}
                disabled={!retrievedData.dls}
              >
                What If Scenario
              </Button>
            )}
            {isEventPlanner && (
              <Button
                onClick={_ => setEventPlanner(true)}
                type="primary"
                disabled={
                  !retrievedData.dls || isErrorContains(retrievedData.errors)
                }
              >
                Event Planner
              </Button>
            )}
            {/* <Filler /> */}
            <Button
              onClick={exportMarginData}
              icon="export"
              type="dashed"
              style={{ marginLeft: '5px' }}
              disabled={!retrievedData.dls}
            >
              Export to PDF
            </Button>
            <Button
              onClick={exportData}
              icon="export"
              type="dashed"
              style={{ marginLeft: '5px' }}
              disabled={!retrievedData.dls}
            >
              Export
            </Button>
          </div>
        </div>
      </CriteriaRow>
      {/* <CriteriaRow style={{ paddingTop: '0px', gridColumnGap: '10px' }}>
        <Filler />
        <Button
          onClick={exportMarginData}
          icon="export"
          type="dashed"
          style={{ marginLeft: '5px' }}
        >
          Export to PDF
        </Button>
        <Button onClick={exportData} icon="export" type="dashed">
          Export
        </Button>
      </CriteriaRow> */}

      {showHourlyDetails && (
        <HourlyDetailsModal
          visible={showHourlyDetails}
          setClose={_ => setShowHourlyDetails(false)}
          unitId={getUnitNameId(unitSelection[1])}
          isEventPlanner={isEventPlanner}
        />
      )}

      <FullHeightSizer heightOffset={280}>
        {({ height, width }) => {
          return (
            <Content
              style={{
                height: height + 20,
                display: 'grid',
                gridTemplateRows: 'min-content auto 100px',
                gridRowGap: '5px',
                overflowY: 'auto',
              }}
            >
              <div
                style={{
                  display: 'grid',
                  gridTemplateColumns: 'min-content min-content min-content',
                  gridTemplateRows: '230px',
                  overflowY: 'hidden',
                  overflowX: 'auto',
                }}
              >
                <CommercialRechart
                  actualWidth={pichartWidth}
                  actualHeight={actualHeight}
                  extraWidth={250}
                  isEventPlanner={isEventPlanner}
                />
                <LostMarginRechartPie
                  actualWidth={pichartWidth}
                  actualHeight={actualHeight}
                  extraWidth={250}
                  isEventPlanner={isEventPlanner}
                />
                {byCauseCode && (
                  <CauseCodeGroupReChartPie
                    actualWidth={1000}
                    actualHeight={actualHeight}
                    extraWidth={250}
                    isEventPlanner={isEventPlanner}
                  />
                )}
                {!byCauseCode && (
                  <MonthlyGraphData
                    actualWidth={700}
                    actualHeight={actualHeight}
                    isEventPlanner={isEventPlanner}
                  />
                )}
              </div>
              <div style={{ minHeight: '210px' }}>
                {!byCauseCode && (
                  <EventData
                    height={height - 300 - 70}
                    width={width - 50}
                    CLIENT={CLIENT}
                    isEventPlanner={isEventPlanner}
                  />
                )}
                {byCauseCode && (
                  <EventSummaryByCauseCode
                    width={width - 50}
                    height={height}
                    CLIENT={CLIENT}
                  />
                )}
              </div>
              <div>
                <EventTotals
                  width={width - 50}
                  height={70}
                  CLIENT={CLIENT}
                  isEventPlanner={isEventPlanner}
                />
              </div>
            </Content>
          )
        }}
      </FullHeightSizer>
      {eventPlanner && (
        <EventPlannerDialog
          visible={eventPlanner}
          onOk={_ => setEventPlanner(false)}
          onClose={_ => setEventPlanner(false)}
          targetInfo={targetInfo}
          lostType={lostType}
          isEventPlanner
        />
      )}
    </div>
  )
}

// const MarginAnalysisContextComponent = props => (
//   <MarginAnalysisProvider>
//     <MarginAnalysis {...props} />
//   </MarginAnalysisProvider>
// )

const mapStateToProps = state => ({
  utilityNameMap: getUtilityNameMap(state),
  unitNameMap: getUnitNameMap(state),
  units: getUnits(state),
  targetInfo: getApiTargetInfo(state),
  CLIENT: getClientInfo(state),
  userInfo: getUserInfo(state),
  pnodeZoneList: getPnodeZoneEffective(state),
  validYearRange: getValidYearRange(state),
})
export default connect(mapStateToProps)(MarginAnalysis)
